import { colors2, ellipsis, transition, UI_BODY_SEMIBOLD_SM_DF } from "oolib";
import styled from "styled-components";


export const StyledCustomSelect = styled.div`
  border: none;
  height: 3.6rem;
  border-radius: 3.7rem;
  background-color: ${({isActive}) => isActive ? colors2.grey10 : "none"};
  padding: 0 1rem 0 1.2rem;
  display: flex;
  gap: 0.4rem;
  align-items: center;
  cursor: pointer;
  max-width: ${({ useFixedWidth, maxWidth }) => useFixedWidth && maxWidth ? `${maxWidth}px` : '100%'};
  &:hover {
    background-color: ${colors2.grey10};
  };
`;

export const StyledLinkWrapper = styled(UI_BODY_SEMIBOLD_SM_DF)`
  width: 100%;
  ${({ useFixedWidth }) => useFixedWidth ? ellipsis : ''}
`